import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  '& > *': {
    width: '100%',
    padding: 0,
    margin: 0,
    border: 'none',
    background: 'none',
    textAlign: 'left',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  }
}));

const ContextualMenu = ({ icon: Icon, children }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        onClick={handleClick}
        size="small"
        aria-controls={open ? 'contextual-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <Icon />
      </IconButton>
      <Menu
        id="contextual-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 2,
            sx: {
              minWidth: "fit-content",
              borderRadius: '8px',
              mt: 1,
              '& .MuiList-root': {
                padding: '0',
              }
            }
          }
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        {React.Children.map(children, (child) => (
          <StyledMenuItem sx={{width: "fit-content"}} disableRipple>
            {child}
          </StyledMenuItem>
        ))}
      </Menu>
    </>
  );
};

ContextualMenu.propTypes = {
  icon: PropTypes.elementType.isRequired,
  children: PropTypes.node.isRequired,
};

export default ContextualMenu; 